import {AppSettings} from '../constants';
import Jwt from '../helper/interceptors';
import { ObjToParam, MapResponse } from '../helper/helper-api';

const portal = AppSettings.clientTypeValue ? AppSettings.clientTypeValue.toLowerCase() : '';
const prefixUrl = `/api/${portal}/accounts`;
// const prefixUrl = `/api/${AppSettings.CLIENT_TYPE_VALUE[0].value.toLowerCase()}/accounts`;

export const addUserToClient = (params) => {
  return Jwt(AppSettings.SITE_ONE_SERVICE_URI).post(`${prefixUrl}/add-user-to-client`, params)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const searchAccounts = (params) => {
  return Jwt(AppSettings.SITE_ONE_SERVICE_URI).get(`${prefixUrl}/search?${ObjToParam(params)}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getById = (params) => {
  return Jwt(AppSettings.SITE_ONE_SERVICE_URI).get(`${prefixUrl}/${params}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getAllfaq = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
  .get(`/api/faq/all`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};


export const getByEmail = (params) => {
  return Jwt(AppSettings.SITE_ONE_SERVICE_URI).get(`${prefixUrl}/by-email/${params}`)
    .then((response) => {
      if (response.status === 204) {
        return {
          statusCode: 200,
          data: null
        };
      }
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const create = (params) => {
  return Jwt(AppSettings.SITE_ONE_SERVICE_URI).post(`${prefixUrl}/invite`, params)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const update = (params) => {
  return Jwt(AppSettings.SITE_ONE_SERVICE_URI).put(`${prefixUrl}/edit-user-info`, params)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const profilePhoto = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI).post(`/api/v2/homeowner/account/upload-picture`, params)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const deleteprofilePhoto = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI).delete(`/api/v2/homeowner/account/remove-picture`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const resendInvite = (params) => {
  return Jwt(AppSettings.SITE_ONE_SERVICE_URI).post(`${prefixUrl}/resend-invite`, params)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const resetPassword = (params) => {
  return Jwt(AppSettings.SITE_ONE_SERVICE_URI).post(`${prefixUrl}/send-email-reset-password`, params)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const resendConfirmemail = (params) => {
  return Jwt(AppSettings.SITE_ONE_SERVICE_URI).post(`${prefixUrl}/resend-confirm-email`, params)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const remove = (params) => {
  return Jwt(AppSettings.SITE_ONE_SERVICE_URI).delete(`${prefixUrl}/${params.userId}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const changePassword = (params) => {
  return Jwt(AppSettings.SITE_ONE_SERVICE_URI).put(`${prefixUrl}/change-password`, params)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const suspendUser = (params) => {
  return Jwt(AppSettings.CURRENT_SITE_URI).put(`/oauth/${params.userid}/suspend`, {})
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const fetchUsersCloseOption = (params) => {
    return Jwt(AppSettings.SITE_ONE_SERVICE_URI).get(`/api/builder/accounts/UserList-by-email?email=${params}`)
    .then((response) => {
      return MapResponse(response);
    }).catch((error) => {
      var response = error.response;
      return MapResponse(response);
    });
};



// WEBPACK FOOTER //
// ./src/User/api.js